/**
 * Typed environment configuration.
 * All REACT_APP_* variables must be declared here and sourced from .env files.
 */
export const ENV = {
  /** Backend host, e.g. http://localhost:8000 / https://mopsc-as-ecpt-nonprod.mo360cp.i.mercedes-benz.com*/
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:8000',
  /** Authentication service host, e.g. http://localhost:8001 / https://mopsc-as-auth-nonprod.mo360cp.i.mercedes-benz.com*/
  AUTH_BASE_URL: process.env.REACT_APP_AUTH_BASE_URL ?? 'http://localhost:8001',
  /** Chatbot API base URL */
  CHATBOT_API_URL: process.env.REACT_APP_CHATBOT_API_URL ?? 'https://app-mopsc-appstation-ecpt-ai-chatbot-be-dev-neu.azurewebsites.net',
  /** Chatbot WebSocket URL */
  CHATBOT_WS_URL: process.env.REACT_APP_CHATBOT_WS_URL ?? 'wss://app-mopsc-appstation-ecpt-ai-chatbot-be-dev-neu.azurewebsites.net/ws/chat',
} as const;
